import React from "react";
import { useIsMobile } from "../styleUtils";

export default function DisabledContent ({
    children,
    disableWhen
}: {
    children?: any
    disableWhen: "mobile" | "desktop"
}) {
    const isMobile = useIsMobile()
        
    if (disableWhen === "mobile" && !isMobile) {
        return children
    } else if (disableWhen === "desktop" && isMobile) {
        return children
    } else {
        return <div></div>
    }
}